import Application from './application';
import { trackEvent, getQueryStringVariable } from './utilities/index';
import Overlay from "./overlay";

let Results = function (params) {
  // console.log('Results initalizing ' + params);

  /**
   *
   */
    let self = this;
    let mainEl = document.getElementById('main');
    let ResultsElement = document.getElementById( 'results' );
    let primaryTitle = ResultsElement.querySelector('h2.primary' );
    let alternativeTitle = ResultsElement.querySelector('h2.alternative');
    let compareTitle = ResultsElement.querySelector('h2.compare');

  
    let moreButton = ResultsElement.querySelector('.more-button' );
    let fittingButton = ResultsElement.querySelector('.fitting-button' );
    let restartButton = ResultsElement.querySelector('.restart-btn');
    let previousButton = ResultsElement.querySelector('.results-back-btn');
    let ctaButtons = ResultsElement.querySelector('.results .cta-wrapper');
    let compareButtons = ResultsElement.querySelectorAll('.compare-btn');
    let compareData = ResultsElement.querySelector('.compare-panel .product-wrap');
    let showPrimaryButtons = ResultsElement.querySelectorAll('.primary-btn');
    let showAlternativeButtons = ResultsElement.querySelectorAll('.alternative-btn');
    let sendResultsButtons = ResultsElement.querySelectorAll('.send-results');
    
    let timeline;
    let nextPage = "primary";
    let driverId = "";
    let overlay = new Overlay();
    let primaryId = '';
    let alternateId = '';
    let primaryFIid = '';
    let alternateFIid = '';
    let primaryName = '';
    let alternateName = '';
    let recLoft = '';
    let recShaftMake = '';
    let recShaftModel = '';
    let recShaftFlex = '';
    let mode = '';
    let isExpanded = false;
  

    let compareSelects = document.querySelectorAll('select[name="compare-select"]');
    for (let y = 0; y < compareSelects.length; y++) {
        let compareSelect = compareSelects[y];
        let colNumber = y + 1;
        compareSelect.addEventListener('change', function (evt) {
            let newProd = evt.target.value;
            self.populateCompareCol(colNumber, newProd);
        });
    }

  this.open = function() {
    console.log('Results.open=' + nextPage);
    // set new height
    mainEl.classList.add('results-visible');
      window.driverSelector.fillProgressBar();
      window.driverSelector.hideProgressBar();
    this.setResults();
    moreButton = ResultsElement.querySelector('.more-button-' + driverId );
      TweenLite.set([primaryTitle, compareTitle, ctaButtons, compareData], { opacity: 0 });
      ResultsElement.style.display = 'block';
      timeline = new TimelineLite({ onComplete: this.openComplete, onCompleteScope: this });

      let titleToShow = null, resultToShow = null, resultFooter = null;

      if (document.querySelector('.result.active')) {
          document.querySelector('.result.active').classList.remove('active');
      }
      if (document.querySelector('.results-content .results-footer.active')) {
          document.querySelector('.results-content .results-footer').classList.remove('active');
      }

      if (nextPage == 'compare') {

          primaryTitle.style.display = 'none';
          //alternativeTitle.style.display = 'none';
          compareTitle.style.display = 'block';
          titleToShow = compareTitle;
          resultToShow = null;
          document.querySelector('.result').classList.remove('active');

          TweenLite.set([compareData], { opacity: 0 });
          timeline.to([compareData], Application.tweenLength, { opacity: 1 }, Application.tweenStagger);

          showAlternativeButtons.forEach(function (btn) { btn.classList.remove('active'); });
          showPrimaryButtons.forEach(function (btn) { btn.classList.remove('active'); });
          compareButtons.forEach(function (btn) { btn.classList.add('active'); });

      } else if (nextPage == 'alternative') {
          primaryTitle.style.display = 'none';
          //alternativeTitle.style.display = 'block';
          compareTitle.style.display = 'none';
          //titleToShow = alternativeTitle;
          resultToShow = document.querySelector('#result-' + alternateId);
          resultFooter = document.querySelector('.results-content .results-footer');

          showAlternativeButtons.forEach(function (btn) { btn.classList.add('active'); });
          showPrimaryButtons.forEach(function (btn) { btn.classList.remove('active'); });
          compareButtons.forEach(function (btn) { btn.classList.remove('active'); });

      } else {
          primaryTitle.style.display = 'block';
          //alternativeTitle.style.display = 'none';
          compareTitle.style.display = 'none';
          titleToShow = primaryTitle;

          showAlternativeButtons.forEach(function (btn) { btn.classList.remove('active'); });
          showPrimaryButtons.forEach(function (btn) { btn.classList.add('active'); });
          compareButtons.forEach(function (btn) { btn.classList.remove('active'); });
          
          resultToShow = document.querySelector('#result-' + primaryId);
          resultFooter = document.querySelector('.results-content .results-footer');
      }

      if (resultToShow) {
          TweenLite.set([resultToShow], { opacity: 0 });
          resultToShow.classList.add('active');
      }

      if (resultFooter) {
          TweenLite.set([resultFooter], { opacity: 0 });
          resultFooter.classList.add('active');
      }

      timeline.to([titleToShow], Application.tweenLength, { opacity: 1 }, Application.tweenStagger);

      if (resultToShow) {
          timeline.to([resultToShow], Application.tweenLength, { opacity: 1 }, Application.tweenStagger);
      }
      if (resultFooter) {
          timeline.to([resultFooter], Application.tweenLength, { opacity: 1 }, Application.tweenStagger);
      }

      timeline.to([ctaButtons], Application.tweenLength, { opacity: 1 }, Application.tweenStagger);
      timeline.play();

    window.resizeFrame();
  };

    this.testResults = function () {

    }


  this.setResults = function () {
      let partner = false;
      console.log('setResults');
    try {
        if (getQueryStringVariable('partner') === "true") {
            partner = true;
        }
    } catch (e) {
        console.log('Error getting partner query string variables');
    }

      if (partner) {
          
          document.querySelectorAll('.more-button,.send-results,.fitting-button,.virtual-fitting-button,.product-button-wrap .btn-tertiary').forEach(function (el) {
              el.style.display = 'none';
          });
      }
      
      let sortedScores = window.driverSelector.calculateResults();
      let recShaft = window.driverSelector.getShaft(sortedScores[0].id);
      recShaftFlex = window.driverSelector.getRecFlex(sortedScores[0].id, recShaft);
      recLoft = window.driverSelector.getRecLoft(sortedScores[0].id);
      primaryFIid = sortedScores[0].fiId;
      //console.log(sortedScores[0].id, sortedScores[1].id);
      //overlay.setCompareIrons(sortedScores[0].id, sortedScores[1].id);
      
      let mpi = 75;
      if (nextPage === "alternative") {
          driverId = sortedScores[1].id;
          // toggle buttons
          showPrimaryButtons.forEach(function (btn) { btn.classList.remove('active'); });
          compareButtons.forEach(function (btn) { btn.classList.remove('active'); });
          showAlternativeButtons.forEach(function (btn) { btn.classList.add('active'); });
          //showAlternativeButton.style.display = 'none';
          //alternativeTitle.style.display = 'block';
          primaryTitle.style.display = 'none';
          compareTitle.style.display = 'none';

          mpi = Math.min(Math.max(window.driverSelector.getMPI(driverId), 75), 98);
      } else {
          driverId = sortedScores[0].id;
          // toggle buttons
          showPrimaryButtons.forEach(function (btn) { btn.classList.add('active'); });
          compareButtons.forEach(function (btn) { btn.classList.remove('active'); });
          showAlternativeButtons.forEach(function (btn) { btn.classList.remove('active'); });
          compareTitle.style.display = 'none';
          //alternativeTitle.style.display = 'none';
          primaryTitle.style.display = 'block';
          mpi = Math.min(Math.max(window.driverSelector.getMPI(driverId), 81), 100);
      }

      ResultsElement.querySelectorAll('.shaft').forEach(function (elem) {
          elem.classList.remove('active');
      })


      ResultsElement.querySelectorAll('.loft-value').forEach(function (elem) {
          elem.innerHTML = recLoft;
      })

      if (recShaft.length > 0) {
          ResultsElement.querySelectorAll('.shaft-' + recShaft).forEach(function (elem) {
              elem.classList.add('active');
              if (elem.querySelector('.shaft-make')) {
                  recShaftMake = elem.querySelector('.shaft-make').innerText;
              }
              if (elem.querySelector('.shaft-make')) {
                  recShaftModel = elem.querySelector('.shaft-model').innerText;
              }
          })
      }

      ResultsElement.querySelectorAll('.shaft-flex').forEach(function (elem) {
          elem.innerHTML = recShaftFlex;
      })

      // set mpi values on results screen
      console.log('#result-' + driverId + ' .mpi-button-value')
      console.log('setting mpi to ' + mpi);
      let mpiElement = ResultsElement.querySelector('#result-' + driverId + ' .mpi-button-value');
      mpiElement.innerHTML = mpi.toString() + '%';
      // set mpi values on the compare screens
      primaryId = sortedScores[0].id;
      alternateId = sortedScores[1].id;

      //document.getElementById('mpi-' + primaryId).innerHTML = Math.min(Math.max(window.driverSelector.getMPI(primaryId), 81), 100) + '%';
      //document.getElementById('mpi-' + alternateId).innerHTML = Math.min(Math.max(window.driverSelector.getMPI(alternateId), 75), 98) + '%';

      console.log('selected driver id is: ' + driverId);
      ResultsElement.classList.add('show-' + driverId);

      //debugger;
      /*
      let drivers = document.getElementsByClassName('iron-wrap')[0]
      primaryFIid = irons.querySelector('div[data-iron="' + primaryId + '"]').getAttribute('data-driverId');
      alternateFIid = irons.querySelector('div[data-iron="' + alternateId + '"]').getAttribute('data-driverId');
      primaryName = irons.querySelector('div[data-iron="' + primaryId + '"]').getAttribute('data-ironName');
      alternateName = irons.querySelector('div[data-iron="' + alternateId + '"]').getAttribute('data-ironName');
      */
      // track here or in the application?
      trackEvent('Recommendation', 'Primary', sortedScores[0].id);
      //trackEvent('Recommendation', 'Alternative', sortedScores[1].id);

      //if (showPrimaryButton.classList.contains('active')) {
      //    viewedName = primaryName;
      //}
      //else {
      //    viewedName = alternateName;
      //}

      this.populateCompareCol(1, primaryId);
      this.populateCompareCol(2, alternateId);

      //document.getElementById('mpi-' + primaryId).innerHTML = Math.min(Math.max(window.driverSelector.getMPI(primaryId), 81), 100) + '%';
      //document.getElementById('mpi-' + alternateId).innerHTML = Math.min(Math.max(window.driverSelector.getMPI(alternateId), 75), 98) + '%';

    //console.log(sortedScores[0].id, sortedScores[1].id);
      //overlay.setCompareIrons(sortedScores[0].id, sortedScores[1].id);
      
    }


    this.populateCompareCol = function (colNumber, prodId) {
        let compareCol = ResultsElement.querySelector('#compare-drivers .product:nth-child(' + colNumber + ')');

        
        let compareSelect = compareCol.querySelector('select[name="compare-select"]');
        let options = compareSelect.querySelectorAll('option');

        options.forEach(option => {
            option.selected = option.value == prodId;
        });

        let loftOptions = ResultsElement.querySelector('[name="' + prodId + '-compare-lofts"]').value.split(',')                
            .map(num => num.trim())    
            .map(num => `${num}&deg;`)     
            .join(', ');;
        
        compareCol.querySelector('.compare-image').src = ResultsElement.querySelector('[name="' + prodId + '-compare-img"]').value;

        compareCol.querySelector('.attribute-value-head-size').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-head-size"]').value;
        compareCol.querySelector('.attribute-value-loft-options').innerHTML = loftOptions;
        compareCol.querySelector('.attribute-value-best-for').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-best-for"]').value;
        compareCol.querySelector('.attribute-graphic-launch').setAttribute('data-attribute-index', ResultsElement.querySelector('[name="' + prodId + '-compare-launch"]').value);
        compareCol.querySelector('.attribute-graphic-spin').setAttribute('data-attribute-index', ResultsElement.querySelector('[name="' + prodId + '-compare-spin"]').value);
        compareCol.querySelector('.attribute-graphic-launch .compare-launch-mid').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-launch-mid"]').value;
        compareCol.querySelector('.attribute-graphic-launch .compare-launch-high').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-launch-high"]').value;
        compareCol.querySelector('.attribute-graphic-launch .compare-launch-highest').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-launch-highest"]').value;
        compareCol.querySelector('.attribute-graphic-spin .compare-spin-lowest').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-spin-lowest"]').value;
        compareCol.querySelector('.attribute-graphic-spin .compare-spin-lower').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-spin-lower"]').value;
        compareCol.querySelector('.attribute-graphic-spin .compare-spin-low').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-spin-low"]').value;
        compareCol.querySelector('.attribute-graphic-spin .compare-spin-mid').innerHTML = ResultsElement.querySelector('[name="' + prodId + '-compare-spin-mid"]').value;
        //compareCol.querySelector('.buy-link').setAttribute('href', ResultsElement.querySelector('[name="' + prodId + '-compare-shop-url"]').value);

    }  

  this.openComplete = function () {
    // todo: initialize controls
      restartButton.addEventListener('click', this.homeClicked);
      previousButton.addEventListener('click', this.previousClicked);
      sendResultsButtons.forEach(function (btn) {
          btn.addEventListener('click', self.sendResultsClicked);
          if (getQueryStringVariable('sendResult') === "true") {
              btn.setAttribute('style', 'visibility: visible');
          }
      })
      showAlternativeButtons.forEach(function (btn) { btn.addEventListener('click', self.alternativeClicked); })
      showPrimaryButtons.forEach(function (btn) { btn.addEventListener('click', self.primaryClicked); })
      compareButtons.forEach(function (btn) { btn.addEventListener('click', self.compareClicked); })
    // tracking listners
    if (moreButton !== null) {
      moreButton.addEventListener('click', this.moreClicked);
    }
    if (fittingButton !== null) {
        fittingButton.addEventListener('click', this.fittingClicked);
    }
  };

  this.moreClicked = function(event) {
    trackEvent('navigation', 'Results', 'Product Details');
  };

  this.fittingClicked = function(event) {
    trackEvent('navigation', 'Results', 'Find A Fitting Location');
  };

    this.homeClicked = function (event) {
      window.driverSelector.hideProgressBar()
      let override = restartButton.getAttribute('data-url-override');
      closeAccordion();
        self.closeCompare();
        window.resizeFrame();
    if (override === null || override === undefined || override === "") {
      nextPage = "home";
      self.close();
      trackEvent('navigation', 'Home');
    } else {
      // window.location.href = override;
      parent.window.location.href = override;
    }
  };

  this.sendResultsClicked = function () {
      console.log('TODO: Calc sign in or success');
    overlay.openSendResults('sign-in', primaryId, primaryFIid, recLoft, recShaftMake, recShaftModel, recShaftFlex);
  }

  this.previousClicked = function(event) {
      nextPage = "question";
      closeAccordion();
      self.closeCompare();
    window.driverSelector.clearProgressBar(-1);
      self.close();
      window.resizeFrame();
    trackEvent('navigation', 'Previous');
  };
  

  this.primaryClicked = function(event) {
      nextPage = "primary";

      showAlternativeButtons.forEach(function (btn) { btn.classList.remove('active'); });
      showPrimaryButtons.forEach(function (btn) { btn.classList.add('active'); });
      compareButtons.forEach(function (btn) { btn.classList.remove('active'); });

      closeAccordion();
      self.closeCompare();
    self.close();
    trackEvent('navigation', 'Results', 'See Primary Results');
    };

    this.alternativeClicked = function (event) {
        nextPage = "alternative";

        showAlternativeButtons.forEach(function (btn) { btn.classList.add('active'); });
        showPrimaryButtons.forEach(function (btn) { btn.classList.remove('active'); });
        compareButtons.forEach(function (btn) { btn.classList.remove('active'); });

        closeAccordion();
        self.closeCompare();
        self.close();
        trackEvent('navigation', 'Results', 'See Primary Results');
    };

  this.compareClicked = function () {
    // console.log('TODO: Compare!');
      // overlay.openCompareOverlay();
      nextPage = "compare";
      closeAccordion();
      mainEl.classList.add('results-compare');


      compareButtons.forEach(function (btn) { btn.classList.add('active'); });
      showAlternativeButtons.forEach(function (btn) { btn.classList.remove('active'); });
      showPrimaryButtons.forEach(function (btn) { btn.classList.remove('active'); });

      mode = 'compare';

      document.querySelector('.result').classList.remove('active');

      document.querySelector('#compare-drivers').classList.add('active');


      self.close();
      //overlay.openCompareOverlay(function () { });
  }
  
  this.disableControls = function () {
    restartButton.removeEventListener('click', this.homeClicked);
      sendResultsButtons.forEach(function (btn) { btn.removeEventListener('click', self.sendResultsClicked) })
      showAlternativeButtons.forEach(function (btn) { btn.removeEventListener('click', self.alternativeClicked) })
      showPrimaryButtons.forEach(function (btn) { btn.removeEventListener('click', self.primaryClicked) })
      compareButtons.forEach(function (btn) { btn.removeEventListener('click', self.compareClicked) });
    if (moreButton !== null) {
      moreButton.removeEventListener('click', this.moreClicked);
    }
    

    };

    this.closeCompare = function () {
        if (mode == 'compare') {
            console.log('close compare');
            mainEl.classList.remove('results-compare');
            mode = '';
        }
    }

  this.quickHide = function () {
    console.log('quick hide');
    timeline.kill();
    timeline = new TimelineLite({onComplete: quickHideComplete});
    timeline.to([ctaButtons, primaryTitle], Application.tweenLength, {opacity: 0});
    timeline.timeScale(1.5);
    timeline.play();
  }

  function quickHideComplete() {
    console.log('hide compare complete');
    overlay.openCompareOverlay(self.quickShow);
  }

  this.quickShow = function() {
    console.log('quick show');
    timeline.kill();
    timeline = new TimelineLite();
    timeline.to([ctaButtons, primaryTitle], Application.tweenLength, {opacity: 1});
    timeline.timeScale(1.5);
    timeline.play();
    }

    this.exit = function () {
        nextPage = 'home';
        this.close();
    }

  this.close = function () {
    console.log('close ' + nextPage);
    
    this.disableControls();
    if (nextPage === "home") {
      window.driverSelector.hideProgressBar();
    }

      if (typeof timeline !== 'undefined' && timeline) {
          timeline.kill();
      }
    timeline = new TimelineLite({onComplete: closeComplete});
      timeline.to([ctaButtons], Application.tweenLength, { opacity: 0 });
      timeline.to([compareData, document.querySelector('.result.active'), document.querySelector('.results-content .results-footer')], Application.tweenLength, { opacity: 0 });
          
    timeline.to([primaryTitle, compareTitle], Application.tweenLength, { opacity: 0 }, Application.tweenStagger);

    timeline.timeScale(1.5);
    timeline.play();
  };

  function closeComplete() {
        mainEl.classList.remove('results-visible');
        // console.log('closeComplete ' + nextPage);
        timeline.kill();
        timeline = null;
        ResultsElement.style.display = 'none';

        if (nextPage === "home") {
          // console.log('reset');
          nextPage = "primary";
          window.driverSelector.reset();
        } else if (nextPage === "question") {
          // console.log('previous');
          nextPage = "primary";
          window.driverSelector.questionClosed(-1);
        }else if (nextPage === "primary") {
            console.log('primary');
            
          self.open();
        } else if (nextPage === "alternative") {
            
          console.log('alternative');
          self.open();
        } else if (nextPage === "compare") {
            console.log('compare next');
            self.open();
        }
    }


    function closeAccordion() {
        isExpanded = false;
        let accordionWrapper = document.querySelector('.results-accordion-wrapper.is-active');
        if (accordionWrapper) {
            let accordion = document.querySelector('.results-accordion-wrapper.is-active .results-accordion');
            accordion.style.height = 0;
            accordionWrapper.classList.remove('is-active');

            let videoWrapper = accordionWrapper.querySelector('.m-video');
            videoWrapper.innerHTML = '';
        }

        mainEl.classList.remove('results-expanded');
        window.resizeFrame();
    }


    var Accordion = function () {

        var
            toggleItems,
            items;

        var _init = function () {
            toggleItems = document.querySelectorAll('.btn-results-accordion');
            toggleItems = Array.prototype.slice.call(toggleItems);
            items = document.querySelectorAll('.results-accordion');
            items = Array.prototype.slice.call(items);

            _addEventHandlers();
            TweenLite.set(items, { visibility: 'visible' });
            TweenLite.from(items, 0.9, { opacity: 0, x: -100, ease: Power1.easeOut }, 0.3)
        }

        var _addEventHandlers = function () {
            toggleItems.forEach(function (element, index) {
                element.addEventListener('click', _toggleItem, false);
            });
        }

        var _toggleItem = function () {
            var parent = this.parentNode;
            var content = parent.children[1];
            let videoWrapper = parent.querySelector('.m-video');

            if (!parent.classList.contains('is-active')) {
                isExpanded = true;
                parent.classList.add('is-active');
                TweenLite.set(content, { height: 'auto' })
                TweenLite.from(content, 0.6, { height: 0, immediateRender: false, ease: Power1.easeOut })
                mainEl.classList.add('results-expanded');

                if (videoWrapper) {
                    let videoField = parent.querySelector('[name="accordion-video"]');
                    if (videoField) {
                        let iframeUrl = videoField.value;
                        let iframe = '<iframe width="560" height="315" src="' + iframeUrl + '" title="YouTube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe>';


                        videoWrapper.innerHTML = iframe;
                    }
                }
            } else {
                isExpanded = false;
                parent.classList.remove('is-active');
                TweenLite.to(content, 0.3, { height: 0, immediateRender: false, ease: Power1.easeOut })
                mainEl.classList.remove('results-expanded');
                if (videoWrapper) {
                    videoWrapper.innerHTML = '';
                }
            }
            window.resizeFrame();

        }

        return {
            init: _init
        }

    }();

    Accordion.init();

};

export default Results;

